import { render, staticRenderFns } from "./StepUploadVideo.vue?vue&type=template&id=87512d2c&scoped=true"
import script from "./StepUploadVideo.vue?vue&type=script&lang=js"
export * from "./StepUploadVideo.vue?vue&type=script&lang=js"
import style0 from "./StepUploadVideo.vue?vue&type=style&index=0&id=87512d2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87512d2c",
  null
  
)

export default component.exports